import { Drawer as DrawerComponent, DialogProps } from 'vaul'

interface DrawerProps extends Pick<DialogProps, 'open' | 'onOpenChange'> {
  children: React.ReactNode
  trigger?: React.ReactNode
}

export const Drawer = ({ children, trigger, ...rest }: DrawerProps) => (
  <DrawerComponent.Root {...rest} defaultOpen={false}>
    {trigger && (
      <DrawerComponent.Trigger asChild>{trigger}</DrawerComponent.Trigger>
    )}

    <DrawerComponent.Portal>
      <DrawerComponent.Overlay className="fixed inset-0 z-20 bg-[rgba(31,35,38,0.3)]" />

      <DrawerComponent.Content className="fixed inset-x-0 bottom-0 z-30 overflow-hidden rounded-t-[14px] bg-white outline-none px-3 py-2 lg:p-4">
        <DrawerComponent.Title style={{ display: 'none' }} hidden>
          Filtros
        </DrawerComponent.Title>

        <div
          aria-hidden
          className="mx-auto mb-[10px] h-[5px] w-[44px] cursor-pointer rounded-[6px] bg-[rgba(31,35,38,0.3)] max-[650px]:mb-[14px]"
        />

        <div className="flex max-h-[90dvh] w-full justify-center overflow-y-auto">
          <div className="flex w-full max-w-[1466px] flex-col gap-y-3">
            {children}
          </div>
        </div>
      </DrawerComponent.Content>
    </DrawerComponent.Portal>
  </DrawerComponent.Root>
)
